export function getAuthRedirectUrl(redirectTo?: string): string {
  return redirectTo
    ? `/auth-redirect?redirectTo=${encodeURIComponent(redirectTo)}`
    : '/auth-redirect';
}

